import { NgModule } from '@angular/core';
import { DatePipe } from '@angular/common';
import { Routes, RouterModule } from '@angular/router';

import { IonicModule } from '@ionic/angular';

import { CheckoutPage } from './checkout.page';
import { PickupDetailsComponent } from '../../../../modals/pickup-details/pickup-details.component';
import { Ionic4DatepickerModule } from '@logisticinfotech/ionic4-datepicker';

import { IonicTimepickerModule } from '@logisticinfotech/ionic-timepicker';
import { ShoppingSharedModule } from '../../shared/shopping-shared.module';


const routes: Routes = [
  {
    path: '',
    component: CheckoutPage
  }
];

@NgModule({
  imports: [
    ShoppingSharedModule,
    IonicModule,
    Ionic4DatepickerModule,
    IonicTimepickerModule,
    RouterModule.forChild(routes)
  ],
  providers: [DatePipe],
  declarations: [CheckoutPage, PickupDetailsComponent],
  entryComponents: [PickupDetailsComponent]
})
export class CheckoutPageModule { }
